namespace Vit {
    export interface ISergenProperty {
        name: string;
        value: any;
        editor: EditorType | null;
        optional?: boolean;
        lookupValues?: ILookupKeyValue[];

        validate(val: any): string;
    }

    export interface SergnPropertyEditor {
        type: EditorType,
        optional?: boolean,
        onChange?: (newValue?: any, oldValue?: any) => void,
    }

    export class SergenProperty implements ISergenProperty {
        name: string;
        editor: EditorType | null;
        optional?: boolean;
        validator?: (any) => string;

        constructor(name: string, private item: any, private propertyName: string, editor: Vit.EditorType = null, optional?: boolean, private readonly defaultValue: string | number | boolean | null = null, lookupValues?: Vit.ILookupKeyValue[] | (() => Vit.ILookupKeyValue[]), validator?: (any) => string, private onChange?: (newValue?: any, oldValue?: any) => void) {
            this.name = name || propertyName;
            this.editor = editor;
            this.validator = validator;

            if (editor) {
                if (optional != null) {
                    this.optional = optional;
                }

                if (this.defaultValue != null && this.item[this.propertyName] == null) {
                    this.item[this.propertyName] = defaultValue;
                }
            }

            if (lookupValues) {
                if (lookupValues instanceof Array && lookupValues.length) {
                    this.lookupValueProvider = () => {
                        return <ILookupKeyValue[]>lookupValues;
                    };
                } else {
                    this.lookupValueProvider = <() => ILookupKeyValue[]>lookupValues;
                    var selected = item[propertyName];

                    if (selected)
                        if (this.lookupValueProvider instanceof Function) {
                            var values = this.lookupValueProvider();

                            for (var value of values) {
                                if (value.key["Name"] == selected["Name"]) {
                                    item[propertyName] = value.key;
                                }
                            }
                        }
                }
            }

            if (!this.validator) {
                this.validator = (val) => {
                    return null;
                };
            }
        }

        get value(): any {
            return this.item[this.propertyName];
        }

        set value(val: any) {
            const oldValue = this.item[this.propertyName];
            this.item[this.propertyName] = val;

            if (this.onChange) {
                this.onChange.call(this, val, oldValue);
            }
        }

        get lookupValues(): ILookupKeyValue[] {
            return this.lookupValueProvider();
        }

        lookupValueProvider: () => ILookupKeyValue[] = () => undefined;

        validate(val: any): string | null {
            return this.validator(val);
        }
    }

    export enum EditorType {
        TextField = 1,
        NumberField = 2,
        CheckboxField = 3,
        LookupField = 4,
    }

    export interface ILookupKeyValue {
        key: any;
        value: string;
    }
}